module.exports = {"230403001":"育才街道","230403002":"红旗街道","230403003":"新南街道","230403004":"湖滨街道","230403005":"解放街道","230403006":"团结街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230403.json
// module id = 716
// module chunks = 0